import Vue from 'vue'
import VueScrollTo from 'vue-scrollto'
import router from './router'
import store from './store'
import App from './App.vue'
import VueNumber from 'vue-number-animation'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUsers, faAddressBook, faThumbsUp, faHandshake } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

Vue.config.productionTip = false

Vue.use(VueScrollTo, {
  duration: 1000,
  easing: "ease-out",
  x: false,
  y: true
})

Vue.use(VueNumber)

library.add(faUsers, faAddressBook, faThumbsUp, faHandshake)
Vue.component('font-awesome-icon', FontAwesomeIcon)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
